module.exports = __webpack_public_path__ + "img/benefit_zoom-call-with-rams-player.fee20d73.jpg";